var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Chart, ChartCategoryAxis, ChartCategoryAxisItem, ChartSeries, ChartSeriesItem, ChartTooltip, ChartValueAxis, ChartValueAxisItem } from '@progress/kendo-react-charts';
import styles from '../ChartWrapper/styles';
var MultiSeriesBarChart = function (_a) {
    var _b = _a.multiSeriesBarChart, chartCategoryAxisItemProps = _b.chartCategoryAxisItemProps, _c = _b.chartProps, chartProps = _c === void 0 ? {} : _c, chartSeriesItems = _b.chartSeriesItems, chartStyle = _b.chartStyle, chartValueAxisItemProps = _b.chartValueAxisItemProps, customTooltip = _b.customTooltip;
    var classes = styles();
    var multiSeriesToolTip = function (props) {
        var points = props.points, categoryText = props.categoryText;
        return (React.createElement("div", null,
            React.createElement("div", { className: classes.chartTooltipTitle }, categoryText),
            points.map(function (point) { return (React.createElement("div", { key: point.series.name, className: classes.chartTooltipWrapper },
                React.createElement("div", null,
                    React.createElement("div", { className: classes.chartTooltipValueCell },
                        React.createElement("span", { className: classes.bold }, point.value)),
                    React.createElement("div", { className: classes.chartTooltipValueDetails },
                        React.createElement("div", { className: "".concat(classes.chartTooltipIcon), style: {
                                background: "".concat(point.series.color)
                            } }),
                        React.createElement("div", { className: classes.chartTooltipValueDetailsText }, point.series.name))))); })));
    };
    var sharedTooltipRender = function (context) {
        if (customTooltip) {
            var CustomTooltip = customTooltip;
            return React.createElement(CustomTooltip, __assign({}, context));
        }
        return multiSeriesToolTip(context);
    };
    return (React.createElement(Chart, __assign({ style: chartStyle }, chartProps, { transitions: false }),
        React.createElement(ChartTooltip, { shared: true, render: sharedTooltipRender }),
        React.createElement(ChartCategoryAxis, null,
            React.createElement(ChartCategoryAxisItem, __assign({}, chartCategoryAxisItemProps))),
        React.createElement(ChartValueAxis, null,
            React.createElement(ChartValueAxisItem, __assign({}, chartValueAxisItemProps))),
        React.createElement(ChartSeries, null, chartSeriesItems.map(function (chartItem, index) {
            return (React.createElement(ChartSeriesItem
            // eslint-disable-next-line react/no-array-index-key
            , __assign({ 
                // eslint-disable-next-line react/no-array-index-key
                key: "bar-".concat(index) }, chartItem.chartSeriesItemProps, { data: chartItem.chartData })));
        }))));
};
export default MultiSeriesBarChart;
//# sourceMappingURL=MultiSeriesBarChart.js.map